import { ApiBase } from "~/extensions/api";
import { Log } from "~/extensions/utils";
import { GetShinjoCommand, UpdateShinjoshoCommand } from "./commands";
const log = Log.create("KeiyakuApi");
export class KeiyakuApi extends ApiBase {
    changeMail(command) {
        return this.request(command);
    }
    validateCode(command) {
        return this.request(command);
    }
    getShinjosho(nyukyokeiyakuNo) {
        let command = new GetShinjoCommand(nyukyokeiyakuNo);
        return this.request(command);
    }
    updateShinjosho(model, personal, kouzaNumber) {
        let command = new UpdateShinjoshoCommand(model, personal, kouzaNumber);
        return this.request(command);
    }
    loadButtonText() {
        return this.api.get("message/taikyo/button");
    }
}
